import Reflux from "reflux-core"
import RefluxPromise from "reflux-promise"

// Uses the user agent's Promise implementation
Reflux.use(RefluxPromise(window.Promise))

export default Reflux
